module.exports = __webpack_public_path__ + "img/plantio.7224aebb.png";